import { TopupAttentionSettingsDTO } from "../../../../../grpc-api/shared/domains/vlp-billing/vlp-billing-topup-attention-request-response";
export class TopupAttentionSettings {
    Version = 0;
    Enabled = false;
    SoundEnabled = true;
    IconEnabled = true;
    RingCount = 3;
    ReminderMinutes = 5;
    EscalationMinutes = 15;
    MaxReminders = 3;
    MaxAgeDays = 7;
    PopupOnNew = true;
    PopupOnLogin = true;
    constructor(dto?: TopupAttentionSettingsDTO) {
        if (!dto) return;
        this.Version = dto.version;
        this.Enabled = dto.enabled;
        this.SoundEnabled = dto.soundEnabled;
        this.IconEnabled = dto.iconEnabled;
        this.RingCount = dto.ringCount;
        this.ReminderMinutes = dto.reminderMinutes;
        this.EscalationMinutes = dto.escalationMinutes;
        this.MaxReminders = dto.maxReminders;
        this.MaxAgeDays = dto.maxAgeDays;
        this.PopupOnNew = dto.popupOnNew;
        this.PopupOnLogin = dto.popupOnLogin;
    }
    toDto(): TopupAttentionSettingsDTO {
        return TopupAttentionSettingsDTO.create({version: this.Version,
            enabled: this.Enabled,
            soundEnabled: this.SoundEnabled,
            iconEnabled: this.IconEnabled,
            ringCount: this.RingCount,
            reminderMinutes: this.ReminderMinutes,
            escalationMinutes: this.EscalationMinutes,
            maxReminders: this.MaxReminders,
            maxAgeDays: this.MaxAgeDays,
            popupOnNew: this.PopupOnNew,
            popupOnLogin: this.PopupOnLogin,
        });
    }
}
